<form (ngSubmit)="handleSubmit()" #submissionForm="ngForm" novalidate>
  <hr />
  <div class="question-answer-actions">
    <button *ngIf="answerResult == null" class="btn btn-primary question-submit">Mark as Complete</button>
  </div>
</form>
